/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';
import * as Joi from 'joi-browser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Form from '../../../common/Form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { uuidv4 } from '../../../utils/uuid';
import { cipher } from '../../../utils/crypto';
import configENV from '../../../config';
import { determineLanguagePrefixPath } from '../../../../../helpers/determineInternationalizationPath';

import {
    getOrderStatus,
    getFirstItemRecipientZipCode,
    getOrderConfirmationId,
    getFirstItemBillingZipCode,
} from '../../../../../../state/ducks/Checkout/Checkout-Selectors';

import { getDataDictionary, getSSRDeviceType } from '../../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

class DesktopOrderByZipCode extends Form {
    state = {
        data: {
            orderNumber: '',
            zipCode: '',
            recaptcha: '',
        },
        isSubmited: false,
        errors: {},
        replaceMask: {
            orderNumber: '*',
        },
        replaceMaskWith: {
            orderNumber: 'toUpperCase',
        },
    };

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
        }
    }

    verifyCallback=(recaptchaToken) => {
        this.setState({ captchaValue: recaptchaToken });
        if (recaptchaToken) {
            this.setState({ captchaError: '' });
        }
    }

    schema = {
        orderNumber: Joi.string()
            .trim()
            .regex(/^W?\d{8,30}$/i, 'order number format') // this regex will recieve order number with W or without min length 8 max is 30
            .min(8)
            .max(30)
            .required()
            .label('Order Number'),
        zipCode: Joi.string()
            .trim()
            .min(5)
            .max(10)
            .required()
            .label('Recipient Postal Code/Zip Code'),
        billingZipCode: Joi.string()
            .trim()
            .min(5)
            .max(10)
            .required()
            .label('Billing Postal Code/Zip Code'),
        recaptcha: Joi.string()
            .required()
            .label('Recaptcha'),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { isReadyState, error } = props;
        if (
            isReadyState && error && error.errorMessage
        ) {
            const { errors } = this.state;
            const billingZipError = error?.errorMessage?.includes('billing');
            if (billingZipError) errors.billingZipCode = error.errorMessage;
            errors.zipCode = error.errorMessage;
        }
    };

    componentDidMount() {
        this.preFillOrderDetails();
    }

    preFillOrderDetails = () => {
        const {
            orderStatus, zipCode, orderConfirmationId, getBillingZipCode,
        } = this.props;
        if (orderStatus === 'M') {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    zipCode,
                    orderNumber: orderConfirmationId,
                    billingZipCode: getBillingZipCode,
                },
            }));
        }
    }

    doSubmit = (submitData) => {
        const { featureFlags, ssrDeviceType } = this.props;
        const data = { ...this.state.data };
        // hardcode billing zip code for .CA. - only on uat2 and prod
        // This is the billing zip code of house account billing address.
        if (featureFlags?.['is-order-tracking-billing-zipcode-hidden']) data.billingZipCode = 'V7R 4X6';
        const uuid = uuidv4();
        const cipherKey = uuid.slice(0, 8);
        data.uuid = uuid;
        data.cryptedOrderNumber = cipher(cipherKey)(data.orderNumber).replace(
            /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
            '$1-$2-$3-$4-$5',
        );
        data.cryptedZipCode = cipher(cipherKey)(data.zipCode);
        const url = [
            determineLanguagePrefixPath('/order-information/'),
            data.uuid,
            '/',
            data.cryptedOrderNumber,
            '/',
            data.cryptedZipCode,
        ].join('');
        data.featureFlags = featureFlags;
        data.ssrDeviceType = ssrDeviceType;
        data.callBack = { url };
        this.setState({ isSubmited: true }, () => {
            submitData.handleSubmitOrderByZipCode(data);
        });
    };

    render() {
        /* eslint-disable max-len */
        const {
            isReadyState, handleSubmitOrderByZipCode, dataDictionary, featureFlags,
        } = this.props;
        const submitData = { handleSubmitOrderByZipCode };
        const orderNumber = {
            label: getLanguageName() === '/en' ? 'Order Number' : dataDictionary?.['Order Number'] || 'Order Number',
            placeholder: getLanguageName() === '/en' ? 'Enter your Order Number' : dataDictionary?.['Enter your Order Number'] || 'Enter your Order Number',
        };
        const zipCode = {
            label: getLanguageName() === '/en' ? 'Recipient Postal Code/Zip Code' : dataDictionary?.['Recipient Postal Code/Zip Code'] || 'Recipient Postal Code/Zip Code',
            placeholder: getLanguageName() === '/en' ? 'Enter your Recipient Postal Code/Zip Code' : dataDictionary?.['Enter your Recipient Postal Code/Zip Code'] || 'Enter your Recipient Postal Code/Zip Code',
        };
        const billingZipCode = {
            label: getLanguageName() === '/en' ? 'Billing Postal Code/Zip Code' : dataDictionary?.['Billing Postal Code/Zip Code'] || 'Billing Postal Code/Zip Code',
            placeholder: getLanguageName() === '/en' ? 'Enter your Billing Postal Code/Zip Code' : dataDictionary?.['Enter your Billing Postal Code/Zip Code'] || 'Enter your Billing Postal Code/Zip Code',
        };
        const submitBtn = {
            label: getLanguageName() === '/en' ? 'TRACK ORDER' : dataDictionary?.['Track Order']?.toUpperCase() || 'TRACK ORDER',
        };
        const enableBillingZipCodeField = featureFlags?.['is-order-tracking-billing-zipcode-hidden'];
        return (
            <div className="trackOrderContainer">
                <img className="track-icon" src="https://images.contentstack.io/v3/assets/bltff8fca2c07fbcc09/blt2435400f02ee9453/5f91e61f6ffd1b42dc42e374/track-order-icon.png" alt="trac-order-icon" />
                {
                    getLanguageName() === '/en'
                        ? (
                            <>
                                <h1 className="header">Track by Order Number!</h1>
                                <h3 className="sub-header">Please enter your Order Number and Postal Code/Zip Code</h3>
                            </>
                        )
                        :                    (
                            <>
                                <h1 className="header">{dataDictionary?.['Track By Order Number!'] || 'Track by Order Number!'}</h1>
                                <h3 className="sub-header-ca">{dataDictionary?.['Please enter your Order Number and Zip Code'] || 'Please enter your Order Number and Zip Code'}</h3>
                            </>
                        )
                }
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    disabled={!isReadyState}
                >
                    {this.renderInput({
                        name: 'orderNumber',
                        label: orderNumber.label,
                        type: 'text',
                        pattern: '^[wW0-9]*$',
                        length: 30,
                        minLength: 8,
                        desktop: true,
                        placeholder: orderNumber.placeholder,
                    })}
                    {this.renderInput({
                        name: 'zipCode',
                        label: zipCode.label,
                        type: 'text',
                        pattern: '^[a-zA-Z\\s\\-0-9]*$',
                        length: 10,
                        desktop: true,
                        placeholder: zipCode.placeholder,
                    })}
                    {!enableBillingZipCodeField && this.renderInput({
                        name: 'billingZipCode',
                        label: billingZipCode.label,
                        type: 'text',
                        pattern: '^[a-zA-Z\\s\\-0-9]*$',
                        length: 10,
                        desktop: true,
                        placeholder: billingZipCode.placeholder,
                    })}
                    <div className="captchaContainer">
                        {this.renderRecaptcha('recaptcha')}
                    </div>

                    <div className="margin-top-2x opacity1">
                        {this.renderButton({
                            label: submitBtn.label,
                            className: 'submitBtn',
                            type: 'submit',
                            isValidated: false,
                        })}
                    </div>
                </form>
            </div>

        );
    }
}

DesktopOrderByZipCode.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    handleSubmitOrderByZipCode: PropTypes.func,
    orderStatus: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    orderConfirmationId: PropTypes.string.isRequired,
    featureFlags: PropTypes.shape({
        'is-order-page-using-ross-endpoint': PropTypes.bool,
    }).isRequired,
    ssrDeviceType: PropTypes.string.isRequired,
    getBillingZipCode: PropTypes.string.isRequired,
    dataDictionary: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        toggleState: newState.toggleState,
        error: newState.error,
        orderStatus: getOrderStatus(state),
        zipCode: getFirstItemRecipientZipCode(state),
        orderConfirmationId: getOrderConfirmationId(state),
        dataDictionary: getDataDictionary(state),
        getBillingZipCode: getFirstItemBillingZipCode(state),
        ssrDeviceType: getSSRDeviceType(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitOrderByZipCode: (data) => dispatch(EventDispatcher.handleSubmitOrderByZipCode(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopOrderByZipCode));
